import { useMemo } from 'react';

import { Stack } from '@lyearn/ui';
import Breadcrumbs, { BackButton, BreadcrumbProps } from '@/components/Breadcrumbs';
import StatusLabel from '@/modules/corporate/modules/admin/views/LearningContent/components/ListItemCard/StatusLabel';

import { HeaderProps } from '../../types';

type Props = Pick<HeaderProps, 'status' | 'title' | 'onBack'>;

const TITLE_CLASS_OVERRIDES = { Typography: { color: 'text-text-secondary' } };

const EditorHeaderLeftNode = (props: Props) => {
  const { status, title, onBack } = props;

  const breadcrumbs = useMemo<BreadcrumbProps[]>(
    () => [{ label: title, overrides: TITLE_CLASS_OVERRIDES }],
    [title],
  );

  return (
    <Stack alignItems="center" gapX={12}>
      <Breadcrumbs
        backIcon={onBack ? <BackButton onClick={onBack} /> : undefined}
        breadcrumbs={breadcrumbs}
        className="p-0"
      />
      <StatusLabel status={status} />
    </Stack>
  );
};

export default EditorHeaderLeftNode;
